// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"5024ab01","646":"9d909854","903":"3febb94e","950":"39c9a4ce"}[chunkId] + ".chunk.css";
};